import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-ticket-creation',
  templateUrl: './ticket-creation.component.html',
  styleUrls: ['./ticket-creation.component.scss']
})
export class TicketCreationComponent implements OnInit {
public add:any={};
  constructor(public appservice:AppService,public toastr:ToastrService) { }
onSubmit(){
this.appservice.postTable("api/Transaction/insert_TicketRising",this.add).subscribe((res:any)=>{
  if(res){
    this.toastr.success(res.toString(),'Message');
    this.add={};
  }else{
    this.toastr.error('Error in Ticket Creation');
  } });
}
onFileSelect(event: any) {
  const file = event.target.files[0];
  if (file) {
    this.add.TR_FileName = file.name;
    this.add.TR_FileType = file.type;
    const reader = new FileReader();
    reader.onload = () => {
      this.add.TR_Attachment = reader.result;
    };
    reader.readAsDataURL(file);
  }
}
OnEmployeeenter(data:any){
this.appservice.getTable(`api/Transaction/GetEmployeeByCode?EmpCode=${data}`).subscribe((res:any)=>{
  if(res){
    this.add.TR_EmpName=res.EmpName;
    this.add.TR_Dept=res.Dept;
  }else{
    this.toastr.error('Employee Not Found');
    this.add.TR_EmpName='';
    this.add.TR_Dept='';
  }});
}
departmentList = ['HR', 'IT', 'Finance', 'Admin'];
  ngOnInit(): void {
  }

}
